// import moment from 'moment';

// export const getTime = dealOfTheDayProductTimer => {
//   if (!dealOfTheDayProductTimer) {
//     return {
//       hour: '00',
//       min: '00',
//       sec: '00'
//     };
//   }
//   return {
//     year: moment(dealOfTheDayProductTimer).format('YYYY'),
//     month: moment(dealOfTheDayProductTimer).format('MM'),
//     date: moment(dealOfTheDayProductTimer).format('DD'),
//     hour: moment(dealOfTheDayProductTimer).format('HH'),
//     min: moment(dealOfTheDayProductTimer).format('mm'),
//     sec: moment(dealOfTheDayProductTimer).format('ss')
//   };
// };

// export const getCurrentTimeInEpochFormat = () => moment().unix();

export const IsDealStart = (endTime = '') => {
  if (endTime) {
    const startTime = new Date(Number(endTime));
    const currentTime = new Date(Date.now());
    let hr = Math.abs(currentTime.getHours() - startTime.getHours());
    let mins = Math.abs(currentTime.getMinutes() - startTime.getMinutes());
    let secs = Math.abs(currentTime.getSeconds() - startTime.getSeconds());
    if (Math.sign(hr) >= 0 && Math.sign(mins) >= 0 && Math.sign(secs) >= 0) {
      if (hr < 10) {
        hr = `0${hr}`;
      }
      if (mins < 10) {
        mins = `0${mins}`;
      }
      if (secs < 10) {
        secs = `0${secs}`;
      }

      return {
        isDealStart: true,
        hr,
        mins,
        secs
      };
    }
    if (hr < 10) {
      hr = Math.abs(hr);
      hr = `0${hr}`;
    }
    if (mins < 10) {
      mins = Math.abs(mins);
      mins = `0${mins}`;
    }
    if (secs < 10) {
      secs = Math.abs(secs);
      secs = `0${secs}`;
    }
    return {
      isDealStart: false,
      hr,
      mins,
      secs
    };
  }
  return {
    isDealStart: false
  };
};

export const IsDealEnd = (endTime = '') => {
  if (endTime) {
    const currentTime = new Date(Date.now());
    const saleEndTime = new Date(Number(endTime));
    const distance = saleEndTime - currentTime;
    let hr = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let mins = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let secs = Math.floor((distance % (1000 * 60)) / 1000);
    if (Math.sign(hr) <= 0 && Math.sign(mins) <= 0 && Math.sign(secs) <= 0) {
      return {
        isDealEnd: true,
        hr: '0',
        mins: '0',
        secs: '0'
      };
    }
    hr = `${Math.abs(hr)}`;
    mins = `${Math.abs(mins)}`;
    secs = `${Math.abs(secs)}`;
    return {
      isDealEnd: false,
      hr,
      mins,
      secs
    };
  }
  return {
    isDealEnd: true
  };
};
